export const isGuidewire = origin => origin === "oasis";
export const isCore = origin => origin === "ufg_core";
